<template>
  <div>
    <BaseTableList
        :table-set-list="mailist"
        :display-items="mails"
        class="mails-table" />
  </div>
</template>

<style scoped>
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

import * as define from '@/define'
import BaseTableList from '@/components/molecules/BaseTableList'

export default {
  name: 'OrderDetailMails',
  components: {
    BaseTableList
  },
  props: {
    orderMails: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
    }),
    mails () {
      return _.chain(this.orderMails)
        .sortBy([val => moment(val.createdAt)])
        .reverse()
        .value()
    },
    mailist () {
      return [
        { label: 'メール種類', path: 'mailTemplate.templateName', type: 'String', width: 400,
          funcId: define.PermissionKeys.Order.Detail.Mail.TEMPLATE_NAME },
        { label: '送信予定日時', path: 'scheduledSendAt', type: 'Date', width: 400,
          funcId: define.PermissionKeys.Order.Detail.Mail.SCHEDULED_SEND_AT },
        { label: '送信日時', path: 'sentAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Mail.SEND_AT },
        { label: '登録日', path: 'createdAt', type: 'Date', width: 400,
          funcId: define.PermissionKeys.Order.Detail.Mail.CREATED_AT }
      ]
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>
